import type { AxiosInstance } from 'axios'
import type {
    KbHomeData,
    KbCategoryDetail,
    KbArticleDetail,
    KbSearchResult,
} from '../types'

const KB_PREFIX = '/kb'

export async function fetchKbHome(axios: AxiosInstance): Promise<KbHomeData> {
    const res = await axios.get(`${KB_PREFIX}/home`)
    return res.data.data
}

export async function fetchKbCategory(
    axios: AxiosInstance,
    slug: string
): Promise<KbCategoryDetail> {
    const res = await axios.get(`${KB_PREFIX}/category/${slug}`)
    return res.data.data
}

export async function fetchKbArticle(
    axios: AxiosInstance,
    slug: string
): Promise<KbArticleDetail> {
    const res = await axios.get(`${KB_PREFIX}/article/${slug}`)
    return res.data.data
}

export async function searchKb(
    axios: AxiosInstance,
    query: string
): Promise<KbSearchResult[]> {
    const res = await axios.get(`${KB_PREFIX}/search`, {
        params: { q: query },
    })
    return res.data.data.results
}

export async function submitArticleFeedback(
    axios: AxiosInstance,
    articleSlug: string,
    value: 'up' | 'down'
): Promise<{ value: string }> {
    const res = await axios.post(`${KB_PREFIX}/article/${articleSlug}/feedback`, {
        value,
    })
    return res.data.data
}

export async function toggleQuickStartStep(
    axios: AxiosInstance,
    stepId: number
): Promise<{ step_id: number; completed: boolean }> {
    const res = await axios.post(`${KB_PREFIX}/quick-start/${stepId}/toggle`)
    return res.data.data
}

export async function resetQuickStartProgress(
    axios: AxiosInstance
): Promise<void> {
    await axios.post(`${KB_PREFIX}/quick-start/reset`)
}
